import React, { useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { MinusIcon, PlusIcon } from 'lucide-react';
import { faqItems } from '../data/landing';
export function FaqSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section aria-labelledby="faq" className="bg-cream" data-id="element-74" data-mp="1bmv9ynky5qmh">
      <div className="mx-auto max-w-3xl px-5 py-20 lg:py-24" data-id="element-75" data-mp="1gkerbwcxyjin">
        <div className="flex flex-col items-center gap-4 text-center" data-id="element-76" data-mp="248o7ahnh4d1v">
          <span className="text-xs font-semibold uppercase tracking-[0.22em] text-coral" data-id="element-77" data-mp="24bk6saeyz9sf">Dudas frecuentes</span>
          <h2 id="faq" className="font-display text-3xl leading-[1.06] text-ink sm:text-4xl" data-id="element-78" data-mp="1ujeeezkt2qcp">
            Preguntas frecuentes
          </h2>
        </div>

        <div className="mt-12 divide-y divide-line border-y border-line" data-id="element-79" data-mp="1zgws139rptr1">
          {faqItems.map((item, index) => {
          const isOpen = openIndex === index;
          return <div key={item.question} data-id="element-80" data-mp="2rz0lga9bb60w" data-mpi={index}>
                <h3 data-id="element-81" data-mp="2s03gmudo3umm">
                  <button type="button" onClick={() => setOpenIndex(isOpen ? null : index)} aria-expanded={isOpen} aria-controls={`faq-panel-${index}`} className="flex w-full items-center justify-between gap-6 py-5 text-left transition-colors duration-150 ease-out-expo hover:text-coral" data-id="element-82" data-mp="14va93q19eiyo">
                    <span className="text-base font-semibold leading-snug text-ink sm:text-lg" data-id="element-83" data-mp="1emy7yc05b2a6">{item.question}</span>
                    <span className="flex h-7 w-7 shrink-0 items-center justify-center rounded-full border border-line text-ink" data-id="element-84" data-mp="1oj17rb7iyoty">
                      {isOpen ? <MinusIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-85" data-mp="1jjetqzjvh4k3" /> : <PlusIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-86" data-mp="1xjpmy98nmv8f" />}
                    </span>
                  </button>
                </h3>
                <AnimatePresence initial={false} data-id="element-87" data-mp="1sledhzm9umqq">
                  {isOpen ? <motion.div id={`faq-panel-${index}`} initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.22,
                ease: [0.23, 1, 0.32, 1]
              }} className="overflow-hidden" data-id="element-88" data-mp="35eyw2zvw53p">
                      <div className="space-y-3 pb-6 pr-10 text-base leading-relaxed text-muted" data-id="element-89" data-mp="285pscco5q8yn">
                        {item.answer.map(paragraph => <p key={paragraph} data-id="element-90" data-mp="2c6jg961lnnrj">{paragraph}</p>)}
                      </div>
                    </motion.div> : null}
                </AnimatePresence>
              </div>;
        })}
        </div>
      </div>
    </section>;
}